import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <section className="relative h-screen flex items-end justify-center overflow-hidden">
      {/* Background Image - Mobile */}
      <div className="absolute inset-0 z-0 md:hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_4e68cbb234160c27a958960ae0d29519_1eb64d7d.jpg"
          alt="Santos Music Group"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      {/* Background Image - Desktop */}
      <div className="absolute inset-0 z-0 hidden md:block">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_3a8341023fd75492fe1f42fb3c8f8508_1eb64d7d.jpg"
          alt="Santos Music Group"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 sm:bottom-12 left-1/2 transform -translate-x-1/2 z-10">
        <div className="flex flex-col items-center gap-2 animate-bounce">
          <span className="font-sans text-xs text-cream/70 uppercase tracking-widest">{t('hero.scroll')}</span>
          <i className="ri-arrow-down-line text-2xl text-cream/70"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
